import {ModelPrompt} from 'webmodals/model-prompt.es6'

class ConsumerPrompt extends ModelPrompt {
    constructor($uibModal, $session) {
        super($uibModal);
        this.seed = {
            status: 'Active',
            country: 'US',
            salesReps: [$session.salesRepId || $session.userAuthName]
        };
    }
    getTitle(model, action){return `${action} user...`}
    getQueryUrl(model, action){return `QueryConsumers.json?Id=${model && model.id}`;}
    getCommandUrl(model, action){ 
        if (action == 'Change Password') {
            return `ChangePassword.json`;
        } else {
            return `${action}User.json`;
        }
    }
    getModalBodyTemplateUrl(model, action){ 
        if (action == 'Change Password') {
            return 'consumer-change-password-fieldset.html';
        } else {
            return `consumer-${action === 'Delete' ? 'delete-confirmation' : 'fieldset'}.html`;
        }
    }
    changePassword(model){return this._open(model, 'Change Password');}
}

export default ConsumerPrompt;

angular.module('emun.consumer').service('consumerPrompt', ConsumerPrompt);